const DOCUMENT = 'TALENT_WARNING_AND_SUSPENSIONS_';

const actions = {
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',

  /* Add Exception modal */
  ADD_EXCEPTION_REQUEST: DOCUMENT + 'ADD_EXCEPTION_REQUEST',
  ADD_EXCEPTION_SUCCESS: DOCUMENT + 'ADD_EXCEPTION_SUCCESS',
  CHANGE_VALUE: DOCUMENT + 'CHANGE_VALUE',
  CLEAR_MODAL_STORE: DOCUMENT + 'CLEAR_MODAL_STORE',
  HIDE_MODAL: DOCUMENT + 'HIDE_MODAL',
  LOAD_FORM_DATA_REQUEST: DOCUMENT + 'LOAD_FORM_DATA_REQUEST',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  SHOW_MODAL: DOCUMENT + 'SHOW_MODAL',
  TOUCH: DOCUMENT + 'TOUCH',
  SET_FILE_LIST: DOCUMENT + 'SET_FILE_LIST',
  SUBMIT_ACTION_REQUEST: DOCUMENT + 'SUBMIT_ACTION_REQUEST',
  SUBMIT_ACTION_SUCCESS: DOCUMENT + 'SUBMIT_ACTION_SUCCESS',

  clearStore: payload => ({ type: actions.CLEAR_STORE, payload }),
  loadData: payload => ({ type: actions.LOAD_REQUEST, payload }),
  loadDataSuccess: payload => ({ type: actions.LOAD_SUCCESS, payload }),

  /* Add Exception modal */
  addExceptionRequest: payload => ({ type: actions.ADD_EXCEPTION_REQUEST, payload }),
  addExceptionSuccess: () => ({ type: actions.ADD_EXCEPTION_SUCCESS }),
  changeValue: payload => ({ type: actions.CHANGE_VALUE, payload }),
  clearModalStore: () => ({ type: actions.CLEAR_MODAL_STORE }),
  hideModal: payload => ({ type: actions.HIDE_MODAL, payload }),
  loadFormData: payload => ({ type: actions.LOAD_FORM_DATA_REQUEST, payload }),
  loadFormDataSuccess: payload => ({ type: actions.LOAD_FORM_DATA_SUCCESS, payload }),
  showModal: payload => ({ type: actions.SHOW_MODAL, payload }),
  touch: data => ({ type: actions.TOUCH, payload: data }),
  setFileList: data => ({ type: actions.SET_FILE_LIST, payload: data }),
  submitActionRequest: data => ({ type: actions.SUBMIT_ACTION_REQUEST, payload: data }),
  submitActionSuccess: data => ({ type: actions.SUBMIT_ACTION_SUCCESS, payload: data }),
};

export default actions;
